<template>
  <v-app-bar dense app color="primary">
    <v-app-bar-nav-icon color='claro' @click.stop="abrirBarra"></v-app-bar-nav-icon>
    <v-toolbar-title class="claro--text"><h5>Instituto Tecnológico de Parral</h5> </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="onLogout" color="claro">mdi-logout</v-icon>
  </v-app-bar>
</template>

<script>
  export default {
    name: "BarraPrincipalAdmin",
    data() {
      return {};
    },

    methods: {
      abrirBarra() {
        this.$emit("abrir", true);
      },  

      onLogout() {
        sessionStorage.removeItem("datax");
        this.$router.push({ name: "AdminLogin" });
      },
    },
  };
</script>